import { useCallback } from 'react'

import {
  useAchievementsStore,
  AchievementSlug,
  useAchievementsActions,
} from '@store'

import { useShowAchievementOverlay } from '../useShowAchievementOverlay'

type UseUnlockAchievementParams = {
  withShowAchievement?: boolean
  delay?: number
}

export const useUnlockAchievement = ({
  withShowAchievement = true,
}: UseUnlockAchievementParams = {}) => {
  const loading = useAchievementsStore.store.isLoading()
  const { unlockAchievement: unlockFromStore, getAchievementBySlug } =
    useAchievementsActions()
  const { showOverlay } = useShowAchievementOverlay()

  const unlockAchievement = useCallback(
    async (slug: AchievementSlug) => {
      const achievement = getAchievementBySlug(slug)

      if (achievement) {
        return { response: { ok: false }, unlockedAchievement: achievement }
      }

      const unlockedAchievement = await unlockFromStore(slug)

      if (withShowAchievement && unlockedAchievement) {
        showOverlay({
          title: unlockedAchievement.name,
          description: unlockedAchievement.description,
          image: unlockedAchievement.iconUrl,
          isAnimationImg: true,
        })
      }

      return { response: { ok: !!unlockedAchievement }, unlockedAchievement }
    },
    [withShowAchievement, unlockFromStore, getAchievementBySlug, showOverlay]
  )

  return {
    loading,
    unlockAchievement,
  }
}
